import React from "react"
import DfbHeadline from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline"
import Section from "@dfb/gatsby-dfb-theme/src/components/blocks/section"
import DfbImage from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image"
import DfbButton from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button"
import { useTranslations } from "@dfb/gatsby-dfb-theme/src/hooks/useTranslations"

const MHeroCollectionSlider = ({ data }) => {
  const t = useTranslations()

  return (
    <Section baseClass="m-Hero m-Hero--slider" data={data}>
      <div
        className="dfb-Slider dfb-Slider--noMargin m-Hero-slider"
        data-transition="slide"
        data-autoplay
        data-indicators
        data-drag
        data-controls
        role="region"
      >
        <div className="dfb-Slider-slider">
          <ul className="dfb-Slider-slides">
            {data.map((item, index) => (
              <li
                className={
                  "dfb-Slider-slideItem m-Hero-item " +
                  (index === 0 ? "is-open" : null)
                }
                data-index={index}
                key={`hero-slide-${index}`}
              >
                <div className="m-Hero-itemImage">
                  <DfbImage
                    image={item.image}
                    aspect_ratio="3:1"
                    add_class="dfb-Image--overlay dfb-Image--opacity55"
                  ></DfbImage>
                </div>
                <div className="m-Hero-itemContent">
                  {item.overline && (
                    <div className="m-Hero-itemCategory">{item.overline}</div>
                  )}
                  {item.headline && (
                    <DfbHeadline
                      headline={item.headline}
                      headline_level="h2"
                      add_class="m-Hero-itemHeadline"
                    />
                  )}
                  {item.link && item.link.url && (
                    <DfbButton
                      tagName="a"
                      link={item.link.url}
                      text={
                        item?.alternative ||
                        item.link?.title ||
                        t("dfb_anchor.morelink")
                      }
                      add_class="u-Theme-dark m-Hero-itemButton"
                    />
                  )}
                </div>
                <div className="m-Hero-itemProgressBar">
                  <div className="m-Hero-itemProgressBarFill" />
                </div>
              </li>
            ))}
          </ul>
        </div>
        <ul className="dfb-Slider-controls">
          <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
            <DfbButton
              icon_type="Dropdown Left"
              tagName="button"
              add_class="dfb-Slider-control dfb-Slider-control--previous"
            />
          </li>
          <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
            <DfbButton
              icon_type="Dropdown Right"
              tagName="button"
              add_class="dfb-Slider-control dfb-Slider-control--next"
            />
          </li>
        </ul>
      </div>
    </Section>
  )
}

export default MHeroCollectionSlider
